import Badge from "@/components/atoms/Badge";

type Props = {
  year: number | null;
};

const LastYearUpdatedBadge = ({ year }: Props) => {
  return year && <Badge color={"natural"} label={year.toString()} size={"sm"} />;
};

export default LastYearUpdatedBadge;
